<template>
  <v-container fluid fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              insert_chart
            </v-icon>
            <span class="title">Dashboard</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <v-card outlined>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-text-field
                          v-model="dateRangeText"
                          label="Rentang tanggal"
                          readonly
                          dense>
                        </v-text-field>
                        <v-date-picker
                          v-model="filter.rangedate"
                          :rules="[rules.required]"
                          full-width
                          range>
                        </v-date-picker>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-btn
                          large
                          block
                          color="success"
                          class="mt-1"
                          dark
                          @click="updateDashboard">
                          Ubah
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="12" class="text-right py-0">
                        <span class="caption">
                          Tekan tombol <span class="red--text font-weight-bold">UBAH</span> untuk menampilkan Report.
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="8">
                <div class="text-center" v-if="loading.dashboard">
                  <v-progress-circular
                    :width="3"
                    color="red"
                    indeterminate>
                  </v-progress-circular>
                </div>
                <v-card
                  v-if="!loading.dashboard"
                  outlined
                  class="mx-auto"
                  light>
                  <v-card-text>
                    <v-row v-show="stockOptionsAll.series.length">
                      <v-col cols="12" md="12" class="pb-0">
                        <span class="title black--text">Profile Layanan</span>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-card
                          class="mx-auto text-center"
                          color="red"
                          dark>
                          <v-card-text>
                            <v-icon size="40" dark>mdi-vote</v-icon>
                            Jumlah penilai
                          </v-card-text>
                          <v-card-text>
                            <div class="display-1">
                              {{ datasummary.tpenilai }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-card
                          class="mx-auto text-center"
                          color="orange"
                          dark>
                          <v-card-text>
                            <v-icon size="40" dark>mdi-star-box-multiple</v-icon>
                            Total nilai
                          </v-card-text>
                          <v-card-text>
                            <div class="display-1">
                              {{ datasummary.tnilai }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-card
                          class="mx-auto text-center"
                          color="primary"
                          dark>
                          <v-card-text>
                            <v-icon size="40">mdi-star-box</v-icon>
                            Rating
                          </v-card-text>
                          <v-card-text>
                            <div class="display-1">
                              {{ datasummary.rnilai }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="12" class="px-0">
                        <div
                          class="display-1">
                          <highcharts
                            class="stock"
                            :options="stockOptionsAll"
                            ref="highchartstockall">
                          </highcharts>
                        </div>
                      </v-col>
                      <v-col cols="12" md="12" class="pb-0">
                        <span class="title black--text">Profile masing-masing unit</span>
                      </v-col>
                      <v-col cols="12" md="12" class="pt-0">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">
                                  Name
                                </th>
                                <th class="text-left">
                                  Rating
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="item in tblsummary"
                                :key="item.name">
                                <td>{{ item.name }}</td>
                                <td>{{ item.avgdata }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                    <h3 v-show="!stockOptionsAll.series.length">
                      Ubah parameter untuk menemukan data yang lain!
                    </h3>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DashboardKepuasanAdmin',
  data: () => ({
    loading: {
      dashboard: false,
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    filter: {
      unit: null,
      rangedate: [],
    },
    varsemua: 'Semua',
    listunit: [],
    datasummary: {
      tnilai: 0,
      tpenilai: 0,
      rnilai: 0,
    },
    tblsummary: [],
    rules: {
      required: (value) => !!value || 'Required.',
    },
    stockOptionsAll: {
      chart: {
        type: 'line',
      },
      title: {
        text: 'Grafik laju rating',
        align: 'left',
      },
      xAxis: {
        type: 'category',
        categories: [],
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Rating',
        },
      },
      tooltip: {
        headerFormat: 'Tanggal: {point.x}<br>',
        pointFormat: 'Rating: {point.y:.1f}<br>',
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
          },
        },
      },
      series: [],
    },
  }),
  created: () => ({
  }),
  mounted() {
    this.updateDashboard();
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'useremail',
    ]),
    dateRangeText() {
      return this.filter.rangedate.join(' ~ ');
    },
  },
  methods: {
    getUnit() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/unit/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listunit = resdata.data;
                // if (this.listunit.length > 0) {
                //   this.filter.unit = this.listunit[0];
                // }
                const allfilter = {
                  nama_unit: 'Semua',
                  id_unit: 'all',
                };
                this.listunit.push(allfilter);
                this.filter.unit = allfilter;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    updateDashboard() {
      if (this.tokenscr) {
        // console.log(this.filter);
        this.loading.dashboard = true;
        this.stockOptionsAll.xAxis.categories = [];
        this.stockOptionsAll.series = [];
        this.datasummary = {
          tnilai: 0,
          tpenilai: 0,
          rnilai: 0,
        };
        let start = new Date(this.filter.rangedate[0]);
        let end = new Date(this.filter.rangedate[1]);
        if (start > end) {
          start = this.filter.rangedate[1];
          end = this.filter.rangedate[0];
        } else {
          start = this.filter.rangedate[0];
          end = this.filter.rangedate[1];
        }
        const datasend = {
          startdate: start,
          enddate: end,
        };
        // console.log(datasend);
        this.axios
          .get(
            this.api + '/api/survey/dashboard',
            {
              params: datasend,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                console.log(resdata);
                if (resdata.data.length > 0) {
                  const category = [];
                  const series = [];
                  const dgroup = [];
                  let penilai = 0;
                  let totalnilai = 0;
                  let listgroup = {};
                  for (const row of resdata.data) {
                    penilai += parseInt(row.jum, 10);
                    totalnilai += parseInt(row.tnilai, 10);
                    category.push(row.tgl);
                    series.push(parseFloat(row.rating));
                    listgroup = {
                      tgl: row.tgl,
                      rating: parseFloat(row.rating),
                    };
                    (dgroup['Desa Blimbingsari'] = dgroup['Desa Blimbingsari'] || []).push(listgroup);
                  }
                  // generate date
                  let listtgl = [];
                  listtgl = category.filter((item, pos) => {
                    return category.indexOf(item) === pos;
                  });
                  // generate data
                  let datachart = null;
                  const listdata = [];
                  Object.keys(dgroup).forEach((key) => {
                    // put each date
                    const eachdate = [];
                    let toteach = 0;
                    for (const tgl of listtgl) {
                      let isadd = false;
                      for (const dg of dgroup[key]) {
                        if (dg.tgl === tgl) {
                          toteach += parseFloat(dg.rating);
                          eachdate.push(dg.rating);
                          isadd = true;
                        }
                      }
                      if (!isadd) {
                        eachdate.push(0);
                      }
                    }
                    // generate series
                    const avgd = parseFloat((toteach / dgroup[key].length).toFixed(1));
                    datachart = {
                      name: key + ' (' + avgd + ')',
                      data: eachdate,
                      avgdata: avgd,
                    };
                    listdata.push(datachart);
                  });
                  // generate grafik
                  this.stockOptionsAll.xAxis.categories = listtgl;
                  this.stockOptionsAll.series = listdata;
                  // table summary
                  this.tblsummary = listdata;
                  // data summary
                  this.datasummary.tnilai = totalnilai;
                  this.datasummary.tpenilai = penilai;
                  this.datasummary.rnilai = parseFloat((totalnilai / penilai).toFixed(1));
                }
              }
            }
            this.loading.dashboard = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.dashboard = false;
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
